import {
  EmptyStateNoResultIllustration,
  EmptyStateProps,
} from '@ardoq/status-ui';
import { OnButtonClick } from './types';
import { TertiaryButton } from '@ardoq/button';
import { t, type I18nLocale } from '@ardoq/i18n';

export type NoNumericFieldsInComponentTypeArgs = {
  openViewSettingsPanel: OnButtonClick;
  openManageFieldsModal: OnButtonClick;
  showActionControls?: boolean;
  i18nLocale: I18nLocale;
};

export const noNumericFieldsInComponentType = ({
  openViewSettingsPanel,
  openManageFieldsModal,
  showActionControls = true,
  i18nLocale,
}: NoNumericFieldsInComponentTypeArgs): EmptyStateProps => ({
  media: <EmptyStateNoResultIllustration />,
  title: t(
    i18nLocale,
    'tabview:graphViews.emptyStateLayout.noNumericFieldsInComponentType.title',
    'No number field in selected component type'
  ),
  description: t(
    i18nLocale,
    'tabview:graphViews.emptyStateLayout.noNumericFieldsInComponentType.description',
    'Add a number field to the selected component type or change the component type.'
  ),
  children: !showActionControls ? null : (
    <>
      <TertiaryButton onClick={openManageFieldsModal}>
        {t(
          i18nLocale,
          'tabview:graphViews.emptyStateLayout.noNumericFieldsInComponentType.addField',
          'Add field'
        )}
      </TertiaryButton>
      <TertiaryButton onClick={openViewSettingsPanel}>
        {t(
          i18nLocale,
          'tabview:graphViews.emptyStateLayout.noNumericFieldsInComponentType.changeComponentType',
          'Change component type'
        )}
      </TertiaryButton>
    </>
  ),
});
